<template>
    <div>
        <b-container fluid class="m-0 px-0 min-vh-100">
            
            <router-view name="header"></router-view>
            
            <!-- 값은 완료 체크한 문항 비율이다 (답변만 하고 체크하지 않은 문항은 세지 않는다) -->
            <b-progress :max="100" class="sticky-top answering-progress" style="z-index: 100" v-if="number_of_questions > 0">
                <b-progress-bar :max="100" :value="progress_rate" :label="progress_rate > 15 ? progress_label : ''"></b-progress-bar>
                <span v-if="progress_rate <= 15" class="answering-progress-outside-label">{{ progress_label }}</span>
            </b-progress>

            <div v-if="is_restoring" class="text-center py-5 my-5">
                <b-spinner variant="primary"></b-spinner>
                <p class="gray-600 mt-3">{{ $t('평가 정보를 불러오는 중입니다.') }}</p>
            </div>
            <b-row v-else no-gutters class="m-0 p-0 align-items-sm-stretch w-100 position-relative" style="overflow-x:hidden;">
                <!-- 왼쪽 사이드 패널 -->
                <!-- 809px 이하에서는 기본으로 숨고 mobile-open 일 때 열린다 (데스크톱에서는 영향 없음) -->
                <b-col id="sidebar" :class="[is_mobile_sidebar_open ? 'mobile-open':'', 'm-0 p-0 ']">
                    <div :class="home_active_sytle==true?'bgray-200':'bgray-650'" class="h-100">
                        <router-view name="aside" ></router-view>
                    </div>
                </b-col>              

                <b-col class="m-0 p-0">
                    <b-container fluid class="m-0 p-0 h-100">
                    <b-row no-gutters id="main" class="w-100 h-100">
                        <!-- 메인 패널 -->
                        <b-col class="m-0 text-left">
                            <!-- 휴대폰·작은 태블릿에서 숨겨진 문항 목록을 여는 버튼 -->
                            <div class="mobile-question-list-toggle px-3 pt-3">
                                <b-button variant="dark-border" size="sm"
                                          aria-controls="sidebar"
                                          :aria-expanded="is_mobile_sidebar_open ? 'true' : 'false'"
                                          @click="toggleSidebar"
                                >
                                    <fa icon="list" class="mr-1"></fa>{{ $t('문항 목록') }}
                                </b-button>
                            </div>
                            <router-view :question_code="question_code"></router-view>
                        </b-col>

                        <!-- 오른쪽 사이드 패널 -->
                        <div class="d-none d-sm-block h-100" :class="home_active_sytle==true?'bgray-100':'bgray-100'">
                            <b-col id="right-side" :class="[is_right_side_collapsed==true ? 'collapsed' : '', ' m-0 px-4 position-relative h-100']">
                                <participate-tools></participate-tools>
                            
                                <b-button variant="right-collapse" class="border-0 rounded-0"
                                          :aria-label="is_right_side_collapsed ? $t('도구 패널 펼치기') : $t('도구 패널 접기')"
                                          :aria-expanded="is_right_side_collapsed ? 'false' : 'true'"
                                          @click.stop="toggleRightSide"
                                >
                                    <span v-if="is_right_side_collapsed==true"> <fa icon="angle-double-left"></fa> </span>
                                    <span v-else> <fa icon="angle-double-right"></fa> </span>
                                </b-button>
                            </b-col>
                        </div>                    
                        <back-to-top></back-to-top>
                    </b-row>
                    </b-container>
                </b-col>
            </b-row>

            <router-view name="footer"></router-view>
            
        </b-container>

        <!-- 도움이 필요하신가요 모달 -->
        <b-button id="need-help" v-b-tooltip.hover.focus class="rounded-circle position-fixed" variant="dark" size="lg" :title="$t('도움이 필요하신가요?')" :aria-label="$t('도움이 필요하신가요?')" @click="showNeedHelp"><fa icon="question"></fa></b-button>
        <b-modal ref="need-help" size="lg" :title="$t('서비스 문의하기')"  hide-footer><customer-service @close-need-help="hideNeedHelp"></customer-service></b-modal>

    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import CustomerService from '@shared_components/utils/CustomerService'
import ParticipateTools from '@shared_components/client/components/ParticipateTools'

export default {
    name: "ParticipateMaster",
    components: {
        CustomerService,
        ParticipateTools
    },
    props: {
        question_code: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            is_mobile_sidebar_open: false,
            is_right_side_collapsed: false,
            is_restoring: false
        }
    },
    computed: {
        ...mapState(['campaign_in_progress', 'user_id', 'template_in_progress_loaded']),
        ...mapState('industry_campaigns', ['custom_template_loaded']),
        home_active_sytle() {
            return this.$route.name !== 'Questions'
        },
        progress_rate() {
            return Math.min(this.$store.getters.getProgressRate, 100)
        },
        number_of_questions() {
            return this.$store.getters.getNumberOfQuestions
        },
        progress_label() {
            return this.$t('완료 체크 {n}/{m}', {n: this.$store.getters.getNumberOfCompletedQuestions, m: this.number_of_questions})
        },
        // 이 레이아웃 안에서 평가 대상이 바뀌는지 본다 (안내↔문항 이동은 같은 값)
        participate_target() {
            if (!['ParticipatePreface', 'Questions'].includes(this.$route.name)) return ''
            const { pc, cmp, cpn } = this.$route.query
            return `${pc || ''}|${cmp || ''}|${cpn || ''}`
        }
    },
    watch: {
        // 히스토리로 다른 평가의 문항에 바로 돌아오면 이 레이아웃은 다시 만들어지지 않아 created 복원이 돌지 않는다
        participate_target(target) {
            if (target) this.syncWithUrl()
        },
        // 휴대폰에서 문항·안내로 이동하면 목록을 닫는다
        '$route.path'() {
            this.is_mobile_sidebar_open = false
        }
    },
    async created () {
        await this.syncWithUrl()
    },
    beforeDestroy(){
        this.update_custom_project_code('')
        this.update_custom_template_loaded(false)
    },
    methods: {
        ...mapMutations('industry_campaigns', ['update_custom_project_code','update_custom_template_loaded']),
        ...mapActions(['read_company_recieved_campaigns']),
        ...mapActions('industry_campaigns', ['enterCampaignContext']),
        // URL(pc/cmp/cpn)이 단일 진실 원천. store 의 평가 컨텍스트가 URL 과 같고 템플릿까지 로드돼 있을 때만 true
        isStoreInSyncWithUrl () {
            const { cmp, cpn } = this.$route.query
            const campaign = this.campaign_in_progress
            return !!campaign.campaign_id
                && String(campaign.campaign_id) === String(cmp)
                && String(campaign.request_company_id) === String(cpn)
                && this.template_in_progress_loaded === true
                && this.custom_template_loaded === true
        },
        // 복원 중에 URL 이 또 바뀌면 끝난 뒤 최신 URL 로 한 번 더 맞춘다
        async syncWithUrl () {
            if (this.is_restoring) return
            let target
            do {
                target = this.participate_target
                if (this._isDestroyed || !target || this.isStoreInSyncWithUrl()) return
                await this.restoreFromUrl(target)
            } while (target !== this.participate_target)
        },
        // 새로고침/새 탭/뒤로가기로 store 가 비었거나 다른 평가일 때 URL 값으로 입장 컨텍스트를 다시 채운다
        async restoreFromUrl (target) {
            const { pc, cmp, cpn } = this.$route.query
            this.is_restoring = true
            // 다른 평가의 같은 문항 코드가 이전 본문을 그대로 쓰지 않게 문항·본문을 비운다
            this.$store.commit('questions/reset_subs')
            this.$store.commit('update_question_in_progress', {...this.$store.state.question_in_progress, question_code: ''})
            try {
                if (!this.user_id) throw new Error('no user')
                await this.read_company_recieved_campaigns({ user_id: this.user_id })
                const campaign = this.$store.state.seperated_campaigns
                    .flatMap(({ campaigns }) => campaigns)
                    .find(c => String(c.campaign_id) === String(cmp)
                        && String(c.request_company_id) === String(cpn)
                        && (!pc || c.project_code === pc))
                if (!campaign) throw new Error('campaign not found')
                const block_reason = await this.enterCampaignContext(campaign)
                if (block_reason) throw new Error(`blocked: ${block_reason}`)
            } catch (error) {
                // 복원 중 다른 평가로 옮겨 갔거나 화면을 떠났으면 이 실패는 버린다 (syncWithUrl 이 최신 URL 로 다시 맞춘다)
                if (this._isDestroyed || target !== this.participate_target) return
                this.$EventBus.$emit('toast-failure', this.$t('평가 입장 실패'), this.$t('평가 정보를 불러오지 못해 평가 선택 화면으로 이동합니다.'))
                this.$router.replace({ name: 'Main' })
            } finally {
                this.is_restoring = false
            }
        },
        toggleSidebar(){
            this.is_mobile_sidebar_open = !this.is_mobile_sidebar_open
        },
        toggleRightSide() {
            this.is_right_side_collapsed = !this.is_right_side_collapsed
        },
        showNeedHelp(){
            this.$refs['need-help'].show()
        },
        hideNeedHelp(){
            this.$refs['need-help'].hide()
        }
    }
}
</script>

<style scoped>
#need-help {
    bottom: 30px;
    right: 30px;
}
/* 휴대폰에서는 작게, 푸터 링크 위로 올려 겹치지 않게 */
@media (max-width: 575.98px) {
    #need-help {
        bottom: 80px;
        right: 16px;
        transform: scale(.8);
    }
}
/* 문항 목록 버튼은 사이드바가 숨는 폭(layout.scss 809px)에서만 */
.mobile-question-list-toggle {
    display: none;
    text-align: right;
}
@media (max-width: 809px) {
    .mobile-question-list-toggle {
        display: block;
    }
    /* layout.scss 의 #sidebar.collapsed 와 같은 열림 상태. 데스크톱 .collapsed(접힘)와 이름을 나눠 폭을 넓혀도 사이드바가 숨지 않게 한다 */
    #sidebar.mobile-open {
        height: 100%;
        overflow-y: scroll;
        margin-left: 0 !important;
    }
}
.ih-tree{
    text-align: left;
}

.wrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
}

.progress.answering-progress{
    border-radius: 0;
    background-color: var(--gray-100);
}
.progress.answering-progress > .progress-bar {
    background-color: var(--blue);
}
.answering-progress-outside-label {
    align-self: center;
    padding: 0 .5rem;
    font-size: .75rem;
    color: var(--gray-600);
    white-space: nowrap;
}

</style>
